import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ModalBodyWrapper, ModalWrapper, BackgroundContainer } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import ModalHeader from '../../../legacy/React/Components/Common/ModalHeader';
import { initEnterpriseBuilder } from '../actions/steps';
import EnterpriseBuilder from './EnterpriseBuilder';

export const EnterpriseBuilderView: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(initEnterpriseBuilder());
    }, [dispatch]);

    return (
        <ModalWrapper>
            <ModalHeader title={<LocalizedText textKey={TextKey.EnterpriseBuilder} />} />
            <ModalBodyWrapper>
                <BackgroundContainer>
                    {/* @ts-expect-error $TSFixMeError: JSX element type 'EnterpriseBuilder' does not have any construct or call signatures. */}
                    <EnterpriseBuilder />
                </BackgroundContainer>
            </ModalBodyWrapper>
        </ModalWrapper>
    );
};
